export const RequestStatus = [
  { id: 0, name: "PENDING" },
  { id: 1, name: "ACCEPT" },
  { id: 2, name: "REJECT" },
  { id: 3, name: "PAYMENT COMPLETED" },
  { id: 4, name: "APPROVED " },
  { id: 5, name: "COMPLETED" },
];

export enum REFUND_STATUS {
  PENDING = 1,
  REFUNDED = 2,
}

export interface CommonBody {
  hash: string;
  sek: string;
}
export interface Allergy {
  name: string;
  image: string;
  isBlocked: boolean;
  isDeleted: boolean;
  _id: string;
}

export interface Dashboard {
  totalCustomer: number;
  newUsers: number;
  totalEarnings: string;
  totalUsers: number;
  totalAgent: number;
  userEarning?: number;
  agentEarning?: number;
  subscriptionEarning?: number;
  users: [];
  earnings: [];
}

export interface AllUser {
  membershipBought: boolean;
  isSubscription: boolean;
  _id: string;
  name: string;
  email: string;
  phone: string;
  isBlocked?: boolean | undefined;
  countryCode: string;
  image: string;
  profilePic?: string;
  profileStatus: number;
  allergies: [];
  fullName: string;
  normalCred: number;
  highlightCred: number;
  documentStatus: any;
}

export interface cms {
  createdAt: string;
  email: string;
  terms: string;
  phone: string;
  countryCode: string;
  privacy: string;
  aboutUs: string;
  updatedAt: string;
  _id: string;
}

export interface Support {
  query: string;
  createdAt: string;
  _id: string;
  userId: {
    name: string;
    countryCode: string;
    phone: string;
    email: string;
  };
}

export interface Subscription {
  query: string;
  isBlocked: boolean;
  _id: string;
  planName: string;
  planName_ar: string;
  image: string;
  description: string;
  description_ar: string;
  monthlyPrice: string;
  quarterlyPrice: string;
  yearlyPrice: string;
  price: string;
  feature: any;
  validity: string;
  validityUnit?: "months" | "days" | "hours" | "minutes";
  validity_ar?: string;
  normalCredit: string;
  highlightCredit: string;
  acceptRequests: string;
}

/** Purchased subscription record (user bought a plan) */
export interface PurchasedSubscription {
  _id: string;
  planName?: string;
  price?: number;
  validity?: number;
  validityUnit?: "months" | "days" | "hours" | "minutes";
  status?: number;
  paymentStatus?: string;
  paymentMode?: string;
  transactionId?: string;
  expiryDate?: string;
  createdAt?: string;
  normalCredit?: number;
  highlightCredit?: number;
  acceptRequests?: number;
  normalCreditLeft?: number;
  highlightCreditLeft?: number;
  acceptRequestsLeft?: number;
  user?: {
    _id?: string;
    fullName?: string;
    email?: string;
    phone?: string;
    countryCode?: string;
    role?: string;
    image?: string;
  };
  membershipPlan?: {
    _id?: string;
    planName?: string;
    price?: number;
    validity?: number;
  };
}

export interface Notification {
  _id: string;
  isRead: boolean;
  isBroadcast: boolean;
  user: [];
  title: string;
  message: string;
  createdAt: string;
}

export type AppSettingRow = {
  label: string;
  platform: "ios" | "android";
  version: string;
  appUpdate: boolean;
  forceUpdate: boolean;
  maintenance: boolean;
  storeUrl?: string;
  maintenanceMessage?: string;
  lastUpdated?: string | null;
};

export interface Cms {
  agentTermsAndConditions_ar: string;
  agentTermsAndConditions: string;
  agentRequestPrice: string;
  createdAt: string;

  termsAndConditions: string;
  normalCredPrice: string;
  highlightCredPrice: string;
  privacyPolicy: string;
  privacyPolicy_ar: string;
  termsAndConditions_ar: string;
  aboutUs: string;
  updatedAt: string;
  _id: string;
  legal: string;
  legal_ar: string;
  contactUs: {
    phone: string;
    email: string;
    dialCode: string;
    whatsappPhone: string;
    whatsappDialCode: string;
  };
  featureConfig?: {
    version: string;
    platform: string;
    featureFlag: boolean;
  }[];
  appSettings?: AppSettingRow[];
}

export interface Property {
  _id: string;
  name: string;
  name_ar?: string;
  price: string;
  isBlocked: boolean;
  status: number;
  type?: number;
  totalArea: number;
  viewCount?: number;
  searchCount?: number;
  address: string;
  agentName: string;
  mapLink: string;
  areaId: {
    name: string;
    name_ar?: string;
    isBlocked: boolean;
    _id: string;
  };
  subAreaId: {
    name: string;
    name_ar?: string;
    isBlocked: boolean;
    _id: string;
  };
  categoryId: {
    image: string;
    isBlocked: boolean;
    name: string;
    name_ar?: string;
    _id: string;
  };
  subCategoryId: {
    isBlocked: boolean;
    name: string;
    name_ar?: string;
    _id: string;
  };
  userId: {
    countryCode: string;
    phone: string;
    email: string;
    fullName: string;
    image: string;
    role?: string;
  };
  createdByRole?: "user" | "agent";
  createdByAdmin?: boolean;
  listingType: number;
  description: string;
  dontDisturb: boolean;
  negotiablePrice?: boolean;
  image: [];
  publish: boolean;
  expireStatus?: number;
  isRefundRequested?: boolean;
  isResubmit?: boolean;
  isFirstTimeExpired?: boolean;
  isSecondTimeExpired?: boolean;
  autoPublishAttempted?: boolean;
  isDescriptionUpdated?: boolean;
  agentAssigned?: any[];
  createdAt?: string;
  updatedAt?: string;
  publishedAt?: string | null;
  highlightedAt?: string | null;
  expiredAt?: string | null;
  acceptedByAgentAt?: string | null;
  saveForLaterAt?: string | null;
}

export interface Dashboard {
  avgMonthlyEarning: number;
  propertiesForExchange: number;
  propertiesForRent: number;
  propertiesForSale: number;
  totalEarning: number;
  userEarning?: number;
  subscriptionEarning?: number;
  totalProperties: number;
  totalUser: number;
  totalAgent: number;
  agentEarning?: number;
}

export interface Payments {
  highlightCreditsBought: string;
  normalCreditsBought: string;
  amount: number;
  capturedAmount?: number;
  currency?: string;
  isBlocked: boolean;
  _id: string;
  paymentMode: string;
  paymentStatus: number | string;
  paymentType: number;
  transactionId?: string;
  provider?: string;
  providerChargeId?: string;
  providerTransactionId?: string;
  providerOrderId?: string;
  providerStatus?: string;
  failureCode?: string;
  failureMessage?: string;
  cardBrand?: string;
  cardLast4?: string;
  paidAt?: string;
  subscription: {
    highlightCredit: string;
    description: string;
    feature: number;
    paymentStatus: string;
    planName: string;
    price: number;
    status: number;
    tax: number;
    validity: string;
    normalCredit: any;
  };
  user: {
    countryCode: string;
    email: string;
    fullName: string;
    image: string;
    phone: string;
    userName: string;
    _id: string;
  };
  createdAt: any;
  agentAssigned: any;
}

export interface SubAdmin {
  id: number;
  firstName: string;
  lastName: string;
  _id: string;
  name: string;
  email: string;
  phone: string;
  isBlocked?: boolean;
  countryCode: string;
  image: string;
  profileStatus: number;
  permission: [
    {
      name: string;
      isView: boolean;
      isAdd: boolean;
      isDelete: boolean;
      _id: string;
    }
  ];
}
